



































import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'PasswordProtection',
  components: {
    ValidationObserver,
  },
  data() {
    return {
      password: '',
    };
  },
  computed: {
    ...mapGetters('user', ['teacher']),
    studioPassword() {
      return atob(this.teacher.studio_password);
    },
  },
  methods: {
    submit() {
      this.$store.commit('user/SET_LOCAL_STUDIO_PASSWORD', this.password);
    },
  },
});
